import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface ScreenReaderLabelProps {
  label: LangEnum;
}

const ScreenReaderLabel = ({ label }: ScreenReaderLabelProps) => {
  const { translate } = useTranslation();

  return (
    <Typography
      component="span"
      variant="micro2"
      sx={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clipPath: 'inset(50%)',
        whiteSpace: 'nowrap',
      }}
    >
      {translate(label)}
    </Typography>
  );
};

export default ScreenReaderLabel;
